<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="900px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Position"
      text="Edit Position"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="localPosition.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete 
                v-model="localPosition.job_grade_id"
                v-validate="'required'"
                :items="jobGrades"
                label="Job Grade"
                item-text="name"
                item-value="id"
                :error-messages="errors.collect('job_grade_id')"
                data-vv-name="job_grade_id"
                data-vv-as="job grade"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      position: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localPosition: null,
        jobGrades: [],
      }
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.loadJobGrades()
          this.localPosition = { ...this.position }
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.positions().update(this.position.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        return {
          name: this.localPosition.name,
          job_grade_id: this.localPosition.job_grade_id,
        }
      },
      loadJobGrades () {
        this.$api.jobGrades().list()
          .then(res => {
            this.jobGrades = res.data
          })
      },
    },
  }
</script>
